<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-button menuId="main-menu"></ion-menu-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <app-wallet-btn [walletS]="walletS" [credentials]="credentials"></app-wallet-btn>
    </ion-buttons>
    <ion-title>
      <div class="logo-container" (click)="navigateToHome()">
        <ion-img class="header" src="/assets/logos/cmillonario-lightbg.svg"></ion-img>
      </div>
    </ion-title>
    <ion-progress-bar *ngIf="isLoading" type="indeterminate"></ion-progress-bar>
  </ion-toolbar>
</ion-header>
